module.exports = __webpack_public_path__ + "media/images/icon/white/ico_top-question-41ed0addff65a779fe9b3fdc243a0db5.svg";